import React from 'react';
import { Hero } from '../components/Hero';
import { Logos } from '../components/Logos';
import { Problem } from '../components/Problem';
import { CastingCalls } from '../components/CastingCalls';
import { RosterDatabase } from '../components/RosterDatabase';
import { Audiences } from '../components/Audiences';
import { ProductWorkflow } from '../components/ProductWorkflow';
import { Moat } from '../components/Moat';
import { CTA } from '../components/CTA';
import { InfluencerHub, CapterraReviews, Newsletter, CreatorAssetOS } from '../components/HomeExtras';
import { Testimonials, BRAND_TESTIMONIALS } from '../components/Testimonials';
export const Home = () => {
  return <>
      <Hero data-id="element-2345" data-mp="2dhgoku5fng5v" />
      <Logos data-id="element-2346" data-mp="2dhyuyjlt7ari" />
      <Problem data-id="element-2347" data-mp="2dii358lnqksc" />
      <CastingCalls data-id="element-2348" data-mp="2dj9wsdvp28fz" />
      <RosterDatabase data-id="element-2349" data-mp="2dfdrjq5v4mrn" />
      <Audiences data-id="element-2350" data-mp="3kvk44fox8t3v" />
      <ProductWorkflow data-id="element-2351" data-mp="3kw1yf6s0wx95" />
      <Moat data-id="element-2352" data-mp="3kuqv182hprik" />
      <Testimonials title="Loved by top brands and agencies" items={BRAND_TESTIMONIALS} data-id="element-2353" data-mp="3kv0pb7ukiku2" />
      <InfluencerHub data-id="element-2354" data-mp="3oyq9ll47mg9a" />
      <CapterraReviews data-id="element-2355" data-mp="30wjaok4gik28" />
      <CreatorAssetOS data-id="element-2356" data-mp="30vqe2bz7paxt" />
      <CTA data-id="element-2357" data-mp="30w9luzv5eiy4" />
      <Newsletter data-id="element-2358" data-mp="30w02vw8itc1x" />
    </>;
};